import Box from '@eversports/klimt-primitives/legacy/Box'
import Collapse from '@eversports/klimt-primitives/legacy/Collapse'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'

import { Localized } from '../localization/react'

interface Props {
  clampedTextHeight: number
  isDisabled?: boolean
  backgroundColor?: string
}

const ExpandableContent = ({
  children,
  clampedTextHeight,
  isDisabled = false,
  backgroundColor = 'white',
}: React.PropsWithChildren<Props>) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isTextClamped, setIsTextClamped] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(true)

  const toggleCollapse = () => {
    if (isDisabled) return
    setIsCollapsed(!isCollapsed)
  }

  useEffect(() => {
    if (!ref.current) return
    if (ref.current.clientHeight > clampedTextHeight) {
      setIsTextClamped(true)
    }
  }, [])

  return isTextClamped ? (
    <Stack sx={{ position: 'relative' }}>
      <Collapse in={!isCollapsed} collapsedSize={clampedTextHeight}>
        <Box ref={ref}>{children}</Box>
      </Collapse>
      {isCollapsed ? (
        // ACCESSIBILITY TODO - Update <Box /> definition, use the prop component="button"
        <Box
          component="button"
          onClick={toggleCollapse}
          sx={{
            paddingLeft: 2,
            boxShadow: `0 0 4px 4px ${backgroundColor}`,
            backgroundColor,
            position: 'absolute',
            bottom: 0,
            right: 0,
            zIndex: 1,
          }}
        >
          <Text variant="label" color="midnight">
            <Localized id="see-more-content" />
          </Text>
        </Box>
      ) : (
        <Box
          component="button"
          onClick={toggleCollapse}
          sx={{ textAlign: 'right', width: 'fit-content', alignSelf: 'flex-end' }}
        >
          <Text variant="label" color="midnight">
            <Localized id="see-less-content" />
          </Text>
        </Box>
      )}
    </Stack>
  ) : (
    <Box sx={{ maxHeight: clampedTextHeight, overflow: 'hidden' }}>
      <Box ref={ref}>{children}</Box>
    </Box>
  )
}

export default ExpandableContent
